import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SEO from '../components/SEO.js';
import '../index.css';
import FreePlanRegister from '../modules/Subscription Plan/FreePlanRegister.jsx';
import ProPlanSelector from '../modules/Subscription Plan/ProPlanSelector.jsx';
import SupporterPlan from '../modules/Subscription Plan/SupporterPlan.jsx';

function Pricing() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Capture affiliate parameters from URL
    const affid = searchParams.get('affid');
    const ref = searchParams.get('ref');
    const privateCode = searchParams.get('privateCode');

    // Track affiliate visit if affid is present
    if (affid) {
      fetch(`/api/referral/affiliate/track?affid=${encodeURIComponent(affid)}`, {
        method: 'GET',
        credentials: 'include' // Include cookies
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          console.log('Affiliate visit tracked successfully');
        } else {
          console.warn('Failed to track affiliate visit:', data.message);
        }
      })
      .catch(error => {
        console.error('Error tracking affiliate visit:', error);
      });
    }

    // Legacy support for old referral system
    if (ref && privateCode) {
      // Store referral information in localStorage for later use during registration/subscription
      localStorage.setItem('affiliateReferral', JSON.stringify({
        ref,
        privateCode,
        timestamp: Date.now()
      }));
      console.log('Legacy affiliate referral parameters captured:', { ref, privateCode });
    }
  }, [searchParams]);

  const handleContinueToPayment = (planType, billingPeriod) => {
    navigate('/payment/' + planType + '/' + billingPeriod);
  };

  return (
    <>
      <SEO
        title="RapidMind AI Pricing Plans - Choose Your AI Solution"
        description="Explore RapidMind AI pricing plans. From free tier to enterprise solutions, find the perfect plan for your AI content creation needs. Start free and scale as you grow."
        keywords="AI pricing, subscription plans, rapidmind ai plans, free AI tools, pro AI features, enterprise AI solutions, content creation pricing"
        image="/RapidMind 2025.png"
        type="website"
      />
      <div id='Plan' className="pricing-container-with-sidebar">
        <main className="pricing-main-content">
          <div id='Plan' className="pricing-container">
            <h1 className="pricing-title">RapidMind AI Pricing Plans</h1>
            <p className="pricing-subtitle">Choisissez le plan qui vous convient le mieux</p>

            <div className="pricing-cards">
              <FreePlanRegister onContinue={handleContinueToPayment} />
              <ProPlanSelector onContinue={handleContinueToPayment} />
            </div>

            <SupporterPlan />

          </div>
        </main>
      </div>
    </>
  );
}

export default Pricing;
